import * as React from 'react';
const classNames = require('classnames');

import Label from './Label';
import { InputError } from '../../common/utils';

interface Props {
	labelText?: string;
	placeholder?: string;
	value?: string | number;
	onChange?: (value?: {}) => void;
	onKeyPress?: (e: any) => any;
	onKeyUp?: (value?: any) => void;
	onKeyDown?: (value?: any) => void;
	onBlur?: (e: any) => void;
	onFocus?: (e: any) => void;
	onPaste?: (e: any) => void;
	name: string;
	id?: string;
	input?: any; // used by redux form
	defaultValue?: string;
	required?: boolean;
	maxLength?: number;
	type?: string;
	addOnBefore?: {};
	addOnAfter?: {};
	className?: string;
	controlClassName?: string;
	disabled?: boolean;
	min?: number;
	max?: number;
	pattern?: string;
	title?: string;
	error?: InputError;
	helpBlock?: {};
}

const TextInput: React.StatelessComponent<Props> = ({
	className,
	labelText,
	addOnBefore,
	addOnAfter,
	controlClassName,
	helpBlock,
	...props
}) => {
	return (
		<div className={classNames('form-group', className)}>
			{labelText && (
				<Label required={props.required} htmlFor={props.id || props.name}>
					{labelText}
				</Label>
			)}
			<div className="input-group">
				{addOnBefore && (
					<div className="input-group-prepend">
						<div className="input-group-text">{addOnBefore}</div>
					</div>
				)}
				<input
					{...props}
					id={props.id || props.name}
					type={props.type ? props.type : 'text'}
					value={props.value || ''}
					className={classNames(
						'form-control',
						{ 'is-invalid': props.error && props.error.hasError },
						controlClassName
					)}
				/>
				{addOnAfter && (
					<div className="input-group-append">
						<div className="input-group-text">{addOnAfter}</div>
					</div>
				)}
				{helpBlock && <div className="form-help-block form-text text-muted">{helpBlock}</div>}
				{props.error && <div className="invalid-feedback">{props.error.message}</div>}
			</div>
		</div>
	);
};

export default TextInput;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/forms/TextInput.tsx